const moduleMap = {
	"./copilot": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(137)]).then(() => (() => ((__webpack_require__(19137)))));
	},
	"./renderCopilotDrawer": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(931)]).then(() => (() => ((__webpack_require__(73190)))));
	},
	"./renderFeature1": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(428)]).then(() => (() => ((__webpack_require__(49428)))));
	},
	"./renderFeature2": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(585)]).then(() => (() => ((__webpack_require__(23585)))));
	},
	"./renderFeature3": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(719)]).then(() => (() => ((__webpack_require__(64719)))));
	},
	"./renderFeatureList": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(344)]).then(() => (() => ((__webpack_require__(91344)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});